import { render, staticRenderFns } from "./PendingHeader.vue?vue&type=template&id=4e94c90e&"
import script from "./PendingHeader.vue?vue&type=script&lang=js&"
export * from "./PendingHeader.vue?vue&type=script&lang=js&"
import style0 from "./PendingHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports